<div class="md:container p-4 md:mx-auto font-primary">
  <h1 class="mb-6 md:mt-8 font-app-bold text-2xl p-2">
    {{ "offers.title" | translate }}
  </h1>
  <app-offer-card
    [header]="'offers.HC.title' | translate"
    [description]="'offers.HC.description' | translate | safeHtml"
    [quotationProductCode]="createHcQuotationCode"
    [aboutLink]="'offers.HC.aboutLink' | translate"
    (showResourcesLimits)="openResourcesLimitsDialog()"
    (createQuotation)="createNewQuotation($event)"></app-offer-card>
  <h1 class="font-app-bold text-2xl mt-10 mb-6">
    {{ "offers.subjectToCondition" | translate }}
  </h1>
  <app-offer-card
    [header]="'offers.HS.title' | translate"
    [description]="'offers.HS.description' | translate | safeHtml"
    [quotationProductCode]="createHsQuotationCode"
    [aboutLink]="'offers.HS.aboutLink' | translate"
    (showResourcesLimits)="openResourcesLimitsDialog()"
    (createQuotation)="createNewQuotation($event)"></app-offer-card>
  <app-offer-card
    [header]="'offers.HP.title' | translate"
    [description]="'offers.HP.description' | translate | safeHtml"
    [quotationProductCode]="createHpQuotationCode"
    [aboutLink]="'offers.HP.aboutLink' | translate"
    (showResourcesLimits)="openResourcesLimitsDialog(PRODUCT_TYPE_PARIS)"
    (createQuotation)="createNewQuotation($event)"></app-offer-card>
  <app-offer-card
    [header]="'offers.HT.title' | translate"
    [description]="'offers.HT.description' | translate | safeHtml"
    [quotationProductCode]="createHtQuotationCode"
    [aboutLink]="'offers.HT.aboutLink' | translate"
    (showResourcesLimits)="openResourcesLimitsDialog(PRODUCT_TYPE_TOURQUENOISE)"
    (createQuotation)="createNewQuotation($event)"></app-offer-card>
  <br />
  <app-resources-limits-dialog
    [visible]="resourcesLimitsDialogVisible"
    [productType]="selectedProductType"
    (close)="resourcesLimitsDialogClose()"></app-resources-limits-dialog>
</div>
